module.exports = __webpack_public_path__ + "img/1920x700-4.3d8fb166.jpg";